import React from 'react'
import { useLocation } from 'react-router-dom'
import ContentArea from '../components/ContentArea'
import Player from '../components/Player'
import { audioFile } from '../audioUtil'

function PlayerPage() {
  const location = useLocation()
  const split = location.pathname.split(`/`)
  let minutes = ``
  let title = ``
  switch (split[2]) {
    case `bodyscan`:
      title = `Body scan `
      minutes = `${split[3]} minutes`
      break
    case `breathawareness`:
      title = `Breath awareness `
      minutes = `${split[3]} minutes`
      break
    case `medical`:
      title = `Medical Support `
      minutes = `10 minutes`
      break
    case `60`:
      title = `60 to Zero in 10 Seconds `
      minutes = `3 minutes`
      break
    case `peace`:
      title = `Peace and Calm `
      minutes = `16 minutes`
      break

    default:
      title = `Body scan`
  }


  return (
    <ContentArea transparent shadowless fullsize>
      <Player audioSrc={audioFile(`${minutes} ${title}`)} text={`${minutes}\n ${title}`} />
    </ContentArea>
  )
}

export default PlayerPage
